import { combine, createEvent, restore, sample } from 'effector'
import { options } from '~/core/flags'
import { features } from '~/core/flags'
import { register } from '~/core/repository'
import { profilesModel } from '~/entities/profiles'
import * as pinLockFeature from '~/features/pin-lock'

export const init = createEvent()

const setAccountSettingsVisible = createEvent<boolean>()
const setAccessSettingsVisible = createEvent<boolean>()
const setCreditsVisible = createEvent<boolean>()

export const $isAccountSettingsVisible = restore(
  setAccountSettingsVisible,
  false
)
export const $isAccessSettingsVisible = restore(setAccessSettingsVisible, false)
export const $isCreditsVisible = restore(setCreditsVisible, false)

const $showAccessSettings = combine(
  pinLockFeature.$isSettingsEnabled,
  profilesModel.$optimisticProfiles,
  (isPinLockInSettingsEnabled, profiles) =>
    isPinLockInSettingsEnabled ||
    profiles.some((profile) => profile.kidsProfile)
)

sample({
  clock: init,
  source: features.get('inAppCredentialsChangeEnabled', false),
  target: setAccountSettingsVisible,
})

sample({
  clock: init,
  source: $showAccessSettings,
  target: setAccessSettingsVisible,
})

sample({
  clock: init,
  source: options.$movieNightEnabled,
  target: setCreditsVisible,
})

register($isAccountSettingsVisible, '$settings/root/isAccountSettingsVisible')
register($isAccessSettingsVisible, '$settings/root/isAccessSettingsVisible')
register($isCreditsVisible, '$settings/root/isCreditsVisible')
